var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.67 14.67V5.33H1.33v9.34h17.34ZM20 5.33v9.34A1.33 1.33 0 0 1 18.67 16H1.33A1.33 1.33 0 0 1 0 14.67V5.33A1.33 1.33 0 0 1 1.33 4h17.34A1.33 1.33 0 0 1 20 5.33ZM2.67 7A.33.33 0 0 1 3 6.67h4.67A.33.33 0 0 1 8 7v6a.33.33 0 0 1-.33.33H3a.33.33 0 0 1-.33-.33V7ZM10 9.33a.67.67 0 1 0 0 1.34h4a.67.67 0 0 0 0-1.34h-4Zm-.67 3.34A.67.67 0 0 1 10 12h6.67a.67.67 0 1 1 0 1.33H10a.67.67 0 0 1-.67-.66Zm.67-6A.67.67 0 1 0 10 8h5.33a.67.67 0 1 0 0-1.33H10Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCard);
export default ForwardRef;